module.exports = __webpack_public_path__ + "img/zipIcon.96097c10.png";